'use client';

import { Dialog, DialogContent, DialogOverlay } from '@/components/common/new-conception/dialog';
import { Badge } from '@/components/common/new-conception/badge';
import { useEffect, useState } from 'react';
import { Button } from '@/components/common/new-conception/button';
import { Checkbox } from '@/components/common/new-conception/checkbox';
import Link from 'next/link';
import { Card } from '@/components/common/new-conception/card';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';

export function AvanciAdvertisement() {
  const [open, setOpen] = useState(false);
  const [accepted, setAccepted] = useState(false);

  const STORAGE_KEY_VIEWED = 'avanci_viewed';
  const STORAGE_KEY_ACCEPTED = 'avanci_accepted';

  function getAvanciAdvertisements() {
    if (typeof window === 'undefined') return null;
    const viewed = JSON.parse(window.localStorage.getItem(STORAGE_KEY_VIEWED));
    const accepted = JSON.parse(window.localStorage.getItem(STORAGE_KEY_ACCEPTED));
    const isAccepted = viewed && accepted;
    setAccepted(isAccepted);
    setOpen(!isAccepted);
  }

  function setAvanciAdvertisements(viewed, accepted) {
    if (typeof window === 'undefined') return;
    window.localStorage.setItem(STORAGE_KEY_VIEWED, viewed.toString());
    window.localStorage.setItem(STORAGE_KEY_ACCEPTED, accepted.toString());
  }

  function onSubmit(event) {
    event.preventDefault();
    setAvanciAdvertisements(true, accepted);
    setOpen(false);
  }

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    getAvanciAdvertisements();
  }, []);

  return (
    <div>
      <Dialog open={open} onOpenChange={setOpen} position="center">
        <DialogOverlay />
        <DialogContent className="flex flex-col max-w-xl">
          <form className="flex flex-col gap-4" onSubmit={onSubmit}>
            <div className="flex w-full justify-center">
              <Badge
                variant="outline"
                className="text-white border-none animate-pulse bg-gradient-to-r from-teal-500 to-mint-green-100"
              >
                EVOLUÇÃO DE MARCA
              </Badge>
            </div>
            <div className="flex flex-col gap-2">
              <h1 className="font-bold text-2xl text-center">
                A Mavielorh agora é{' '}
                <span className="bg-gradient-to-r from-teal-500 to-mint-green-100 bg-clip-text text-transparent">
                  Avanci.AI
                </span>
              </h1>
              <p className="text-gray-500 text-sm font-light">
                Unimos 10 anos de experiência à inteligência do futuro. Nossa identidade mudou, mas
                nosso compromisso continua sendo potencializar o seu RH através do tripé:
              </p>
              <div className="flex flex-row gap-2 justify-center">
                <Badge variant="outline" className="hover:shadow-sm cursor-pointer">
                  🤝 Pessoas
                </Badge>
                <Badge variant="outline" className="hover:shadow-sm cursor-pointer">
                  🎯 Propósito
                </Badge>
                <Badge variant="outline" className="hover:shadow-sm cursor-pointer">
                  🤖 Tecnologia
                </Badge>
              </div>
            </div>
            <div className="flex justify-center gap-2">
              <Card className="flex flex-row gap-2 items-center justify-center px-2 py-1.5 w-full animate-gradient-pulse">
                <Link
                  href="https://www.avanci.ai/termos-de-uso"
                  target="_blank"
                  className="text-sm hover:underline"
                >
                  <p className="text-sm">Termos de uso</p>
                </Link>
                <ArrowTopRightOnSquareIcon className="w-4 h-4 text-gray-500" />
              </Card>
              <Card className="flex flex-row gap-2 items-center justify-center px-2 py-1.5 w-full  ">
                <Link
                  href="https://www.avanci.ai/politica-de-privacidade"
                  target="_blank"
                  className="text-sm hover:underline"
                >
                  <p className="text-sm">Politica de privacidade</p>
                </Link>
                <ArrowTopRightOnSquareIcon className="w-4 h-4 text-gray-500" />
              </Card>
            </div>
            <Card
              className="bg-white p-2 hover:shadow-md justify-center cursor-pointer"
              onClick={() => {
                setAccepted(!accepted);
              }}
            >
              <div className="flex flex-row gap-2 items-center">
                <Checkbox
                  checked={accepted}
                  onChange={() => {
                    setAccepted(!accepted);
                  }}
                />
                <p className="text-sm">Estou ciente da nova fase Avanci.AI</p>
              </div>
            </Card>
            <Button
              type="submit"
              disabled={!accepted}
              className="bg-gradient-to-r from-teal-500 to-mint-green-100"
            >
              Acessar nova experiência
            </Button>
          </form>
        </DialogContent>
      </Dialog>
    </div>
  );
}
